function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51.992 83.008 C 51.992 86.87 48.862 90 45 90 s -6.992 -3.13 -6.992 -6.992 C 42.67 82.184 47.331 82.184 51.992 83.008 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(191,191,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.899 63.955 c 0.104 0.656 0.166 1.321 0.166 1.991 v 3.473 l 0 0 v 10.973 c 0 1.445 1.172 2.617 2.617 2.617 h 18.635 c 1.445 0 2.617 -1.172 2.617 -2.617 v -10.96 l 0 0 V 65.72 c 0 -0.594 0.056 -1.183 0.143 -1.765 C 49.023 61.598 40.964 61.601 32.899 63.955 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(119,119,119)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.654 77.146 H 33.347 c -2.125 0 -3.864 -1.739 -3.864 -3.864 v 0 c 0 -2.125 1.739 -3.864 3.864 -3.864 h 23.307 c 2.125 0 3.864 1.739 3.864 3.864 v 0 C 60.518 75.408 58.779 77.146 56.654 77.146 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(191,191,191)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.899 63.955 h 24.178 c 0.35 -2.357 1.388 -4.577 3.077 -6.288 c 3.789 -3.842 6.127 -9.118 6.127 -14.94 c 0 -12.551 -10.866 -22.565 -23.704 -21.147 c -10.058 1.111 -18.033 9.404 -18.795 19.495 c -0.486 6.44 1.897 12.331 6.004 16.53 C 31.481 59.339 32.524 61.578 32.899 63.955 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,211,16)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.937 55.762 c -0.251 0 -0.505 -0.049 -0.751 -0.151 c -2.655 -1.104 -4.925 -2.925 -6.565 -5.266 c -1.625 -2.322 -2.559 -5.055 -2.699 -7.902 c -0.053 -1.081 0.779 -2 1.86 -2.053 c 1.08 -0.052 1.999 0.779 2.053 1.86 c 0.104 2.11 0.794 4.132 1.995 5.848 c 1.213 1.732 2.893 3.079 4.859 3.896 c 0.999 0.415 1.472 1.562 1.057 2.56 C 41.434 55.308 40.705 55.762 39.937 55.762 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,233,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 58.094 43.047 c -1.041 0 -1.908 -0.82 -1.955 -1.871 c -0.096 -2.127 -0.786 -4.167 -1.999 -5.899 c -1.201 -1.716 -2.865 -3.056 -4.813 -3.875 c -0.998 -0.419 -1.465 -1.568 -1.046 -2.565 c 0.421 -0.997 1.571 -1.467 2.565 -1.045 c 2.629 1.106 4.878 2.917 6.503 5.239 c 1.639 2.342 2.574 5.098 2.703 7.97 c 0.049 1.081 -0.788 1.996 -1.869 2.045 C 58.154 43.046 58.124 43.047 58.094 43.047 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,233,136)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85.388 44.305 H 74.146 c -1.082 0 -1.959 -0.877 -1.959 -1.959 s 0.877 -1.959 1.959 -1.959 h 11.241 c 1.082 0 1.959 0.877 1.959 1.959 S 86.469 44.305 85.388 44.305 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,211,16)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.855 44.305 H 4.612 c -1.082 0 -1.959 -0.877 -1.959 -1.959 s 0.877 -1.959 1.959 -1.959 h 11.242 c 1.082 0 1.959 0.877 1.959 1.959 S 16.936 44.305 15.855 44.305 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,211,16)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 15.159 c -1.082 0 -1.959 -0.877 -1.959 -1.959 V 1.959 C 43.042 0.877 43.919 0 45 0 c 1.082 0 1.959 0.877 1.959 1.959 v 11.242 C 46.959 14.282 46.082 15.159 45 15.159 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,211,16)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.609 23.696 c -0.501 0 -1.002 -0.191 -1.385 -0.574 c -0.765 -0.765 -0.765 -2.005 0 -2.77 l 7.95 -7.95 c 0.765 -0.765 2.005 -0.765 2.77 0 c 0.765 0.765 0.765 2.005 0 2.77 l -7.95 7.95 C 66.612 23.505 66.111 23.696 65.609 23.696 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,211,16)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.391 23.696 c -0.501 0 -1.003 -0.191 -1.385 -0.574 l -7.949 -7.95 c -0.765 -0.765 -0.765 -2.005 0 -2.77 c 0.764 -0.765 2.006 -0.765 2.77 0 l 7.949 7.95 c 0.765 0.765 0.765 2.005 0 2.77 C 25.393 23.505 24.892 23.696 24.391 23.696 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,211,16)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmart);
export default __webpack_public_path__ + "static/media/smart.e2b3efedbc9b8c745b2242f76fcdbe53.svg";
export { ForwardRef as ReactComponent };